'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useDecisions } from '../../hooks';
import { getENV } from '../../utils/env';
import './one-trust.scss';
export const OneTrustHeadScriptV2 = () => {
  const $ = _c(2);
  const isOneTrust = useDecisions("onetrust");
  if (!isOneTrust) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getENV();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL,
    NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL,
    NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID,
    NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID,
    NEXT_PUBLIC_LOCALE
  } = t0;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  const src = isCA ? NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL : NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL;
  const scriptId = isCA ? NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID : NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Script id="OneTrust-Script" strategy="beforeInteractive" src={src} data-domain-script={scriptId} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};